import get from 'lodash/get';
import {
  FETCH_DSR_LOGS,
  FETCH_DSR_LOGS_SUCCESS,
  FETCH_DSR_LOGS_FAILURE,
  CREATE_DSR_LOG,
  CREATE_DSR_LOG_SUCCESS,
  CREATE_DSR_LOG_FAILURE,
  SUBMIT_DSR_LOG,
  SUBMIT_DSR_LOG_SUCCESS,
  SUBMIT_DSR_LOG_FAILURE,
  UN_SUBMIT_DSR_LOG,
  UN_SUBMIT_DSR_LOG_SUCCESS,
  UN_SUBMIT_DSR_LOG_FAILURE,
  GENERATE_FLASH_REPORT,
  GENERATE_FLASH_REPORT_SUCCESS,
  GENERATE_FLASH_REPORT_FAILURE,
  UPDATE_DSR_LOG_SECTIONS,
  UPDATE_DSR_LOG_SECTIONS_SUCCESS,
  UPDATE_DSR_LOG_SECTIONS_FAILURE,
  FETCH_TECHNICIAN_LOG,
  FETCH_TECHNICIAN_LOG_SUCCESS,
  FETCH_TECHNICIAN_LOG_FAILURE,
  UPDATE_TECHNICIAN_LOG,
  UPDATE_TECHNICIAN_LOG_SUCCESS,
  UPDATE_TECHNICIAN_LOG_FAILURE,
  FETCH_MATERIAL_LOG,
  FETCH_MATERIAL_LOG_SUCCESS,
  FETCH_MATERIAL_LOG_FAILURE,
  UPDATE_MATERIAL_LOG,
  UPDATE_MATERIAL_LOG_SUCCESS,
  UPDATE_MATERIAL_LOG_FAILURE,
  FETCH_CONSUMABLES_LOG,
  FETCH_CONSUMABLES_LOG_SUCCESS,
  FETCH_CONSUMABLES_LOG_FAILURE,
  UPDATE_CONSUMABLES_LOG,
  UPDATE_CONSUMABLES_LOG_SUCCESS,
  UPDATE_CONSUMABLES_LOG_FAILURE,
  FETCH_EQUIPMENT_USAGE_LOG,
  FETCH_EQUIPMENT_USAGE_LOG_SUCCESS,
  FETCH_EQUIPMENT_USAGE_LOG_FAILURE,
  UPDATE_EQUIPMENT_USAGE_LOG,
  UPDATE_EQUIPMENT_USAGE_LOG_SUCCESS,
  UPDATE_EQUIPMENT_USAGE_LOG_FAILURE,
  FETCH_EHS_LOG,
  FETCH_EHS_LOG_SUCCESS,
  FETCH_EHS_LOG_FAILURE,
  UPDATE_EHS_LOG,
  UPDATE_EHS_LOG_SUCCESS,
  UPDATE_EHS_LOG_FAILURE,
  ADD_EHS_LOG_ITEM,
  ADD_EHS_LOG_ITEM_SUCCESS,
  ADD_EHS_LOG_ITEM_FAILURE,
  DELETE_EHS_LOG_ITEM,
  DELETE_EHS_LOG_ITEM_SUCCESS,
  DELETE_EHS_LOG_ITEM_FAILURE,
  FETCH_ALL_EHS_ISSUES,
  FETCH_ALL_EHS_ISSUES_SUCCESS,
  FETCH_ALL_EHS_ISSUES_FAILURE,
  FETCH_DOWNTIME_LOG,
  FETCH_DOWNTIME_LOG_SUCCESS,
  FETCH_DOWNTIME_LOG_FAILURE,
  UPDATE_DOWNTIME_LOG,
  UPDATE_DOWNTIME_LOG_SUCCESS,
  UPDATE_DOWNTIME_LOG_FAILURE,
  ADD_DOWNTIME_LOG_ITEM,
  ADD_DOWNTIME_LOG_ITEM_SUCCESS,
  ADD_DOWNTIME_LOG_ITEM_FAILURE,
  DELETE_DOWNTIME_LOG_ITEM,
  DELETE_DOWNTIME_LOG_ITEM_SUCCESS,
  DELETE_DOWNTIME_LOG_ITEM_FAILURE,
  FETCH_DOWNTIME_EQUIPMENTS,
  FETCH_DOWNTIME_EQUIPMENTS_SUCCESS,
  FETCH_DOWNTIME_EQUIPMENTS_FAILURE,
  FETCH_PRODUCTION_LOG,
  FETCH_PRODUCTION_LOG_SUCCESS,
  FETCH_PRODUCTION_LOG_FAILURE,
  UPDATE_PRODUCTION_LOG,
  UPDATE_PRODUCTION_LOG_SUCCESS,
  UPDATE_PRODUCTION_LOG_FAILURE,
  UPSERT_PRODUCTION_ITEM,
  UPSERT_PRODUCTION_ITEM_SUCCESS,
  UPSERT_PRODUCTION_ITEM_FAILURE,
  DELETE_PIPE_GROUP,
  DELETE_PIPE_GROUP_SUCCESS,
  DELETE_PIPE_GROUP_FAILURE,
  DELETE_PRODUCTION_JOINT,
  DELETE_PRODUCTION_JOINT_SUCCESS,
  DELETE_PRODUCTION_JOINT_FAILURE,
  CLEAR_TECHNICIAN_LOG,
  CLEAR_MATERIAL_LOG,
  CLEAR_CONSUMABLES_LOG,
  CLEAR_EQUIPMENT_USAGE_LOG,
  CLEAR_EHS_LOG,
  CLEAR_DOWNTIME_LOG,
  CLEAR_PRODUCTION_LOG,
} from './types';

const initialState = {
  isDsrLogsLoading: false,
  dsrLogsList: [],
  isCreatingDsrLog: false,
  isSubmittingDsrLog: false,
  isUnSubmitting: false,
  isGeneratingFlashReport: false,
  isUpdatingDsrLogSections: false,
  currentDsrLog: null,
  // Technician log state
  isTechnicianLogLoading: false,
  isUpdatingTechnicianLog: false,
  currentTechnicianLog: null,
  // Material log state
  isMaterialLogLoading: false,
  isUpdatingMaterialLog: false,
  currentMaterialLog: null,
  // Consumables log state
  isConsumablesLogLoading: false,
  isUpdatingConsumablesLog: false,
  currentConsumablesLog: null,
  // Equipment usage log state
  isEquipmentUsageLogLoading: false,
  isUpdatingEquipmentUsageLog: false,
  currentEquipmentUsageLog: null,
  // EHS log state
  isEhsLogLoading: false,
  isUpdatingEhsLog: false,
  isAddingEhsLogItem: false,
  isDeletingEhsLogItem: false,
  isFetchingAllEhsIssues: false,
  currentEhsLog: null,
  allEhsIssues: [],
  // Downtime log state
  isDowntimeLogLoading: false,
  isUpdatingDowntimeLog: false,
  isAddingDowntimeLogItem: false,
  isDeletingDowntimeLogItem: false,
  isFetchingDowntimeEquipments: false,
  currentDowntimeLog: null,
  downtimeEquipments: [],
  // Production log state
  isProductionLogLoading: false,
  isUpdatingProductionLog: false,
  isUpsertingProductionItem: false,
  isDeletingPipeGroup: false,
  isDeletingProductionJoint: false,
  currentProductionLog: null,
};

const dsrReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DSR_LOGS: {
      return {
        ...state,
        isDsrLogsLoading: true,
      };
    }

    case FETCH_DSR_LOGS_SUCCESS: {
      const resData = get(action, 'response', []);
      return {
        ...state,
        dsrLogsList: resData,
        isDsrLogsLoading: false,
      };
    }

    case FETCH_DSR_LOGS_FAILURE: {
      return {
        ...state,
        isDsrLogsLoading: false,
      };
    }

    case CREATE_DSR_LOG: {
      return {
        ...state,
        isCreatingDsrLog: true,
      };
    }

    case CREATE_DSR_LOG_SUCCESS: {
      const dsrLogData = get(action, 'response', null);
      return {
        ...state,
        currentDsrLog: dsrLogData,
        isCreatingDsrLog: false,
      };
    }

    case CREATE_DSR_LOG_FAILURE: {
      return {
        ...state,
        isCreatingDsrLog: false,
      };
    }

    case SUBMIT_DSR_LOG: {
      return {
        ...state,
        isSubmittingDsrLog: true,
      };
    }

    case SUBMIT_DSR_LOG_SUCCESS: {
      return {
        ...state,
        isSubmittingDsrLog: false,
        currentDsrLog: null,
      };
    }

    case SUBMIT_DSR_LOG_FAILURE: {
      return {
        ...state,
        isSubmittingDsrLog: false,
      };
    }

    case UN_SUBMIT_DSR_LOG: {
      return {
        ...state,
        isUnSubmitting: true,
      };
    }

    case UN_SUBMIT_DSR_LOG_SUCCESS: {
      return {
        ...state,
        isUnSubmitting: false,
        currentDsrLog: state.currentDsrLog
          ? {
              ...state.currentDsrLog,
              logSubmitDate: null,
            }
          : null,
      };
    }

    case UN_SUBMIT_DSR_LOG_FAILURE: {
      return {
        ...state,
        isUnSubmitting: false,
      };
    }

    case GENERATE_FLASH_REPORT: {
      return {
        ...state,
        isGeneratingFlashReport: true,
      };
    }

    case GENERATE_FLASH_REPORT_SUCCESS: {
      return {
        ...state,
        isGeneratingFlashReport: false,
      };
    }

    case GENERATE_FLASH_REPORT_FAILURE: {
      return {
        ...state,
        isGeneratingFlashReport: false,
      };
    }

    case UPDATE_DSR_LOG_SECTIONS: {
      return {
        ...state,
        isUpdatingDsrLogSections: true,
      };
    }

    case UPDATE_DSR_LOG_SECTIONS_SUCCESS: {
      const updatedDsrLog = get(action, 'response', null);

      // If the response contains an ID, we assume it's a full DSR log object and use it.
      // Otherwise, we merge it to avoid overwriting the state with a partial object.
      let newDsrLog;
      if (updatedDsrLog?.id) {
        // Full DSR log object returned
        newDsrLog = updatedDsrLog;
      } else if (updatedDsrLog?.sectionsSkipped) {
        // Only sectionsSkipped returned, merge with existing currentDsrLog
        newDsrLog = {
          ...state.currentDsrLog,
          sectionsSkipped: {
            ...state.currentDsrLog?.sectionsSkipped,
            ...updatedDsrLog.sectionsSkipped,
          },
        };
      } else {
        // Fallback: merge whatever is returned
        newDsrLog = { ...state.currentDsrLog, ...updatedDsrLog };
      }

      return {
        ...state,
        currentDsrLog: newDsrLog,
        isUpdatingDsrLogSections: false,
      };
    }

    case UPDATE_DSR_LOG_SECTIONS_FAILURE: {
      return {
        ...state,
        isUpdatingDsrLogSections: false,
      };
    }

    // Technician log cases
    case FETCH_TECHNICIAN_LOG: {
      return {
        ...state,
        isTechnicianLogLoading: true,
      };
    }

    case FETCH_TECHNICIAN_LOG_SUCCESS: {
      const technicianLogData = get(action, 'response', null);
      return {
        ...state,
        currentTechnicianLog: technicianLogData,
        isTechnicianLogLoading: false,
      };
    }

    case FETCH_TECHNICIAN_LOG_FAILURE: {
      return {
        ...state,
        isTechnicianLogLoading: false,
      };
    }

    case UPDATE_TECHNICIAN_LOG: {
      return {
        ...state,
        isUpdatingTechnicianLog: true,
      };
    }

    case UPDATE_TECHNICIAN_LOG_SUCCESS: {
      const updatedTechnicianLog = get(action, 'response', null);
      return {
        ...state,
        currentTechnicianLog: updatedTechnicianLog,
        isUpdatingTechnicianLog: false,
      };
    }

    case UPDATE_TECHNICIAN_LOG_FAILURE: {
      return {
        ...state,
        isUpdatingTechnicianLog: false,
      };
    }

    // Material log cases
    case FETCH_MATERIAL_LOG: {
      return {
        ...state,
        isMaterialLogLoading: true,
      };
    }

    case FETCH_MATERIAL_LOG_SUCCESS: {
      const materialLogData = get(action, 'response', null);
      return {
        ...state,
        currentMaterialLog: materialLogData,
        isMaterialLogLoading: false,
      };
    }

    case FETCH_MATERIAL_LOG_FAILURE: {
      return {
        ...state,
        isMaterialLogLoading: false,
      };
    }

    case UPDATE_MATERIAL_LOG: {
      return {
        ...state,
        isUpdatingMaterialLog: true,
      };
    }

    case UPDATE_MATERIAL_LOG_SUCCESS: {
      return {
        ...state,
        isUpdatingMaterialLog: false,
      };
    }

    case UPDATE_MATERIAL_LOG_FAILURE: {
      return {
        ...state,
        isUpdatingMaterialLog: false,
      };
    }

    // Consumables log cases
    case FETCH_CONSUMABLES_LOG: {
      return {
        ...state,
        isConsumablesLogLoading: true,
      };
    }

    case FETCH_CONSUMABLES_LOG_SUCCESS: {
      const consumablesLogData = get(action, 'response', null);
      return {
        ...state,
        currentConsumablesLog: consumablesLogData,
        isConsumablesLogLoading: false,
      };
    }

    case FETCH_CONSUMABLES_LOG_FAILURE: {
      return {
        ...state,
        isConsumablesLogLoading: false,
      };
    }

    case UPDATE_CONSUMABLES_LOG: {
      return {
        ...state,
        isUpdatingConsumablesLog: true,
      };
    }

    case UPDATE_CONSUMABLES_LOG_SUCCESS: {
      const updatedConsumablesLog = get(action, 'response', null);
      return {
        ...state,
        currentConsumablesLog: updatedConsumablesLog,
        isUpdatingConsumablesLog: false,
      };
    }

    case UPDATE_CONSUMABLES_LOG_FAILURE: {
      return {
        ...state,
        isUpdatingConsumablesLog: false,
      };
    }

    // Equipment usage log cases
    case FETCH_EQUIPMENT_USAGE_LOG: {
      return {
        ...state,
        isEquipmentUsageLogLoading: true,
      };
    }

    case FETCH_EQUIPMENT_USAGE_LOG_SUCCESS: {
      const equipmentUsageLogData = get(action, 'response', null);
      return {
        ...state,
        currentEquipmentUsageLog: equipmentUsageLogData,
        isEquipmentUsageLogLoading: false,
      };
    }

    case FETCH_EQUIPMENT_USAGE_LOG_FAILURE: {
      return {
        ...state,
        isEquipmentUsageLogLoading: false,
      };
    }

    case UPDATE_EQUIPMENT_USAGE_LOG: {
      return {
        ...state,
        isUpdatingEquipmentUsageLog: true,
      };
    }

    case UPDATE_EQUIPMENT_USAGE_LOG_SUCCESS: {
      const updatedEquipmentUsageLog = get(action, 'response', null);
      return {
        ...state,
        currentEquipmentUsageLog: updatedEquipmentUsageLog,
        isUpdatingEquipmentUsageLog: false,
      };
    }

    case UPDATE_EQUIPMENT_USAGE_LOG_FAILURE: {
      return {
        ...state,
        isUpdatingEquipmentUsageLog: false,
      };
    }

    // EHS log cases
    case FETCH_EHS_LOG: {
      return { ...state, isEhsLogLoading: true };
    }
    case FETCH_EHS_LOG_SUCCESS: {
      return { ...state, isEhsLogLoading: false, currentEhsLog: get(action, 'response', null) };
    }
    case FETCH_EHS_LOG_FAILURE: {
      return { ...state, isEhsLogLoading: false };
    }
    case UPDATE_EHS_LOG: {
      return { ...state, isUpdatingEhsLog: true };
    }
    case UPDATE_EHS_LOG_SUCCESS: {
      return { ...state, isUpdatingEhsLog: false };
    }
    case UPDATE_EHS_LOG_FAILURE: {
      return { ...state, isUpdatingEhsLog: false };
    }
    case ADD_EHS_LOG_ITEM: {
      return { ...state, isAddingEhsLogItem: true };
    }
    case ADD_EHS_LOG_ITEM_SUCCESS: {
      return { ...state, isAddingEhsLogItem: false };
    }
    case ADD_EHS_LOG_ITEM_FAILURE: {
      return { ...state, isAddingEhsLogItem: false };
    }
    case DELETE_EHS_LOG_ITEM: {
      return { ...state, isDeletingEhsLogItem: true };
    }
    case DELETE_EHS_LOG_ITEM_SUCCESS: {
      return { ...state, isDeletingEhsLogItem: false };
    }
    case DELETE_EHS_LOG_ITEM_FAILURE: {
      return { ...state, isDeletingEhsLogItem: false };
    }
    case FETCH_ALL_EHS_ISSUES: {
      return { ...state, isFetchingAllEhsIssues: true };
    }
    case FETCH_ALL_EHS_ISSUES_SUCCESS: {
      return {
        ...state,
        isFetchingAllEhsIssues: false,
        allEhsIssues: get(action, 'response.data.rows', []),
      };
    }
    case FETCH_ALL_EHS_ISSUES_FAILURE: {
      return { ...state, isFetchingAllEhsIssues: false };
    }

    // Downtime log cases
    case FETCH_DOWNTIME_LOG:
      return { ...state, isDowntimeLogLoading: true };
    case FETCH_DOWNTIME_LOG_SUCCESS:
      return {
        ...state,
        isDowntimeLogLoading: false,
        currentDowntimeLog: get(action, 'response', null),
      };
    case FETCH_DOWNTIME_LOG_FAILURE:
      return { ...state, isDowntimeLogLoading: false };
    case UPDATE_DOWNTIME_LOG:
      return { ...state, isUpdatingDowntimeLog: true };
    case UPDATE_DOWNTIME_LOG_SUCCESS:
      return { ...state, isUpdatingDowntimeLog: false };
    case UPDATE_DOWNTIME_LOG_FAILURE:
      return { ...state, isUpdatingDowntimeLog: false };
    case ADD_DOWNTIME_LOG_ITEM:
      return { ...state, isAddingDowntimeLogItem: true };
    case ADD_DOWNTIME_LOG_ITEM_SUCCESS:
      return { ...state, isAddingDowntimeLogItem: false };
    case ADD_DOWNTIME_LOG_ITEM_FAILURE:
      return { ...state, isAddingDowntimeLogItem: false };
    case DELETE_DOWNTIME_LOG_ITEM:
      return { ...state, isDeletingDowntimeLogItem: true };
    case DELETE_DOWNTIME_LOG_ITEM_SUCCESS:
      return { ...state, isDeletingDowntimeLogItem: false };
    case DELETE_DOWNTIME_LOG_ITEM_FAILURE:
      return { ...state, isDeletingDowntimeLogItem: false };
    case FETCH_DOWNTIME_EQUIPMENTS:
      return { ...state, isFetchingDowntimeEquipments: true };
    case FETCH_DOWNTIME_EQUIPMENTS_SUCCESS:
      return {
        ...state,
        isFetchingDowntimeEquipments: false,
        downtimeEquipments: get(action, 'response.rows', []),
      };
    case FETCH_DOWNTIME_EQUIPMENTS_FAILURE:
      return { ...state, isFetchingDowntimeEquipments: false };

    // Production log cases
    case FETCH_PRODUCTION_LOG:
      return { ...state, isProductionLogLoading: true };
    case FETCH_PRODUCTION_LOG_SUCCESS:
      return {
        ...state,
        isProductionLogLoading: false,
        currentProductionLog: get(action, 'response.data', []),
      };
    case FETCH_PRODUCTION_LOG_FAILURE:
      return { ...state, isProductionLogLoading: false };
    case UPDATE_PRODUCTION_LOG:
      return { ...state, isUpdatingProductionLog: true };
    case UPDATE_PRODUCTION_LOG_SUCCESS:
      return { ...state, isUpdatingProductionLog: false };
    case UPDATE_PRODUCTION_LOG_FAILURE:
      return { ...state, isUpdatingProductionLog: false };
    case UPSERT_PRODUCTION_ITEM:
      return { ...state, isUpsertingProductionItem: true };
    case UPSERT_PRODUCTION_ITEM_SUCCESS:
      return { ...state, isUpsertingProductionItem: false };
    case UPSERT_PRODUCTION_ITEM_FAILURE:
      return { ...state, isUpsertingProductionItem: false };
    case DELETE_PIPE_GROUP:
      return { ...state, isDeletingPipeGroup: true };
    case DELETE_PIPE_GROUP_SUCCESS:
    case DELETE_PIPE_GROUP_FAILURE:
      return { ...state, isDeletingPipeGroup: false };

    case DELETE_PRODUCTION_JOINT:
      return { ...state, isDeletingProductionJoint: true };
    case DELETE_PRODUCTION_JOINT_SUCCESS:
    case DELETE_PRODUCTION_JOINT_FAILURE:
      return { ...state, isDeletingProductionJoint: false };

    // Clear section data cases
    case CLEAR_TECHNICIAN_LOG:
      return { ...state, currentTechnicianLog: null, isTechnicianLogLoading: false, isUpdatingTechnicianLog: false };
    case CLEAR_MATERIAL_LOG:
      return { ...state, currentMaterialLog: null, isMaterialLogLoading: false, isUpdatingMaterialLog: false };
    case CLEAR_CONSUMABLES_LOG:
      return { ...state, currentConsumablesLog: null, isConsumablesLogLoading: false, isUpdatingConsumablesLog: false };
    case CLEAR_EQUIPMENT_USAGE_LOG:
      return { ...state, currentEquipmentUsageLog: null, isEquipmentUsageLogLoading: false, isUpdatingEquipmentUsageLog: false };
    case CLEAR_EHS_LOG:
      return { ...state, currentEhsLog: null, isEhsLogLoading: false, isUpdatingEhsLog: false, isAddingEhsLogItem: false, isDeletingEhsLogItem: false };
    case CLEAR_DOWNTIME_LOG:
      return { ...state, currentDowntimeLog: null, isDowntimeLogLoading: false, isUpdatingDowntimeLog: false, isAddingDowntimeLogItem: false, isDeletingDowntimeLogItem: false };
    case CLEAR_PRODUCTION_LOG:
      return { ...state, currentProductionLog: null, isProductionLogLoading: false, isUpdatingProductionLog: false, isUpsertingProductionItem: false, isDeletingPipeGroup: false, isDeletingProductionJoint: false };

    default: {
      return state;
    }
  }
};

export default dsrReducer;
